export default __webpack_public_path__ + "fc8d290e3f5356fad7d93f76c6abe188.png";